var N = Object.defineProperty;
var O = (t, e, r) => e in t ? N(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var u = (t, e, r) => (O(t, typeof e != "symbol" ? e + "" : e, r), r), b = (t, e, r) => {
  if (!e.has(t))
    throw TypeError("Cannot " + r);
};
var y = (t, e, r) => (b(t, e, "read from private field"), r ? r.call(t) : e.get(t)), S = (t, e, r) => {
  if (e.has(t))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(t) : e.set(t, r);
}, x = (t, e, r, o) => (b(t, e, "write to private field"), o ? o.call(t, r) : e.set(t, r), r);
import { guardUnspecified as d, guardEmptyString as I } from "@smh/utils/guards";
import { toQueryString as j } from "@smh/utils/url";
const T = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/, P = /^(?:(\w+):)\/\/([\w.-]+)(?::(\d+))?\/(.+)/, _ = "Invalid Dsn";
var g;
class v {
  constructor(e, r = !1) {
    u(this, "protocol");
    u(this, "user");
    u(this, "publicKey");
    u(this, "pass");
    u(this, "host");
    u(this, "port");
    u(this, "path");
    u(this, "projectId");
    S(this, g, void 0);
    x(this, g, r), typeof e == "string" ? this._fromString(e) : this._fromComponents(e), this._validate();
  }
  toString(e = !1) {
    const { host: r, path: o, pass: s, port: n, projectId: i, protocol: c, publicKey: a } = this;
    return `${c}://${a}${e && s ? `:${s}` : ""}@${r}${n ? `:${n}` : ""}/${o && `${o}/`}${i}`;
  }
  get storeEndpoint() {
    const { host: e, path: r, port: o, projectId: s, protocol: n, publicKey: i } = this, c = j({
      sentry_key: i,
      sentry_version: "7"
    });
    return `${n}://${e}:${o}/${r ? `${r}/` : ""}api/${s}/store/${c}`;
  }
  _getDsnParams(e) {
    if (y(this, g)) {
      const [a, h, l = "", f] = e.slice(1);
      return {
        protocol: a,
        host: h,
        port: l,
        lastPath: f,
        publicKey: "",
        pass: ""
      };
    }
    const [r, o = "", s = "", n, i = "", c] = e.slice(1);
    return {
      protocol: r,
      host: n,
      port: i,
      lastPath: c,
      publicKey: o,
      pass: s
    };
  }
  _fromString(e) {
    const r = y(this, g) ? P.exec(e) : T.exec(e);
    if (!r)
      throw new Error(_);
    const { protocol: o, publicKey: s, pass: n, host: i, port: c, lastPath: a } = this._getDsnParams(r);
    let h = "", l = a;
    const f = l.split("/");
    if (f.length > 1 && (h = f.slice(0, -1).join("/"), l = f.pop()), l) {
      const p = l.match(/^\d+/);
      p && (l = p[0]);
    }
    this._fromComponents({
      host: i,
      pass: n,
      path: h,
      projectId: l,
      port: c,
      protocol: o,
      publicKey: s
    });
  }
  _fromComponents(e) {
    "user" in e && !("publicKey" in e) && (e.publicKey = e.user), this.user = e.publicKey || "", this.protocol = e.protocol, this.publicKey = e.publicKey || "", this.pass = e.pass || "", this.host = e.host, this.port = e.port || "", this.path = e.path || "", this.projectId = e.projectId;
  }
  _validate() {
    const e = ["protocol", "host", "projectId"];
    if (y(this, g) || e.push("publicKey"), e.forEach((r) => {
      if (!this[r])
        throw new Error(`${_}: ${r} missing`);
    }), !this.projectId.match(/^\d+$/))
      throw new Error(`${_}: Invalid projectId ${this.projectId}`);
    if (this.protocol !== "http" && this.protocol !== "https")
      throw new Error(`${_}: Invalid protocol ${this.protocol}`);
    if (this.port && isNaN(parseInt(this.port, 10)))
      throw new Error(`${_}: Invalid port ${this.port}`);
  }
}
g = new WeakMap();
const m = "?", R = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, K = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, C = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i, A = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, M = /\((\S*)(?::(\d+))(?::(\d+))\)/, U = /Minified React error #\d+;/i;
function D(t) {
  let e = null, r = 0;
  t && (typeof t.framesToPop == "number" ? r = t.framesToPop : U.test(t.message) && (r = 1));
  try {
    if (e = W(t), e)
      return k(e, r);
  } catch {
  }
  try {
    if (e = q(t), e)
      return k(e, r);
  } catch {
  }
  return {
    message: E(t),
    name: t && t.name,
    stack: [],
    failed: !0
  };
}
function q(t) {
  if (!t || !t.stack)
    return null;
  const e = [], r = t.stack.split(`
`);
  let o, s, n, i;
  for (let c = 0; c < r.length; ++c) {
    if (n = R.exec(r[c])) {
      const a = n[2] && n[2].indexOf("native") === 0;
      o = n[2] && n[2].indexOf("eval") === 0, o && (s = M.exec(n[2])) && (n[2] = s[1], n[3] = s[2], n[4] = s[3]);
      let h = n[2] && n[2].indexOf("address at ") === 0 ? n[2].substr(11) : n[2], l = n[1] || m;
      const f = l.indexOf("safari-extension") !== -1, p = l.indexOf("safari-web-extension") !== -1;
      (f || p) && (l = l.indexOf("@") !== -1 ? l.split("@")[0] : m, h = f ? `safari-extension:${h}` : `safari-web-extension:${h}`), i = {
        url: h,
        func: l,
        args: a ? [n[2]] : [],
        line: n[3] ? +n[3] : null,
        column: n[4] ? +n[4] : null
      };
    } else if (n = C.exec(r[c]))
      i = {
        url: n[2],
        func: n[1] || m,
        args: [],
        line: +n[3],
        column: n[4] ? +n[4] : null
      };
    else if (n = K.exec(r[c]))
      o = n[3] && n[3].indexOf(" > eval") > -1, o && (s = A.exec(n[3])) ? (n[1] = n[1] || "eval", n[3] = s[1], n[4] = s[2], n[5] = "") : c === 0 && !n[5] && t.columnNumber !== void 0 && (e[0].column = t.columnNumber + 1), i = {
        url: n[3],
        func: n[1] || m,
        args: n[2] ? n[2].split(",") : [],
        line: n[4] ? +n[4] : null,
        column: n[5] ? +n[5] : null
      };
    else
      continue;
    !i.func && i.line && (i.func = m), e.push(i);
  }
  return e.length ? {
    message: E(t),
    name: t.name,
    stack: e
  } : null;
}
function W(t) {
  if (!t || !t.stacktrace)
    return null;
  const e = t.stacktrace, r = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i, o = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\((.*)\))? in (.*):\s*$/i, s = e.split(`
`), n = [];
  let i;
  for (let c = 0; c < s.length; c += 2) {
    let a = null;
    (i = r.exec(s[c])) ? a = {
      url: i[2],
      func: i[3],
      args: [],
      line: +i[1],
      column: null
    } : (i = o.exec(s[c])) && (a = {
      url: i[6],
      func: i[3] || i[4],
      args: i[5] ? i[5].split(",") : [],
      line: +i[1],
      column: +i[2]
    }), a && (!a.func && a.line && (a.func = m), n.push(a));
  }
  return n.length ? {
    message: E(t),
    name: t.name,
    stack: n
  } : null;
}
function k(t, e) {
  try {
    return {
      ...t,
      stack: t.stack.slice(e)
    };
  } catch {
    return t;
  }
}
function E(t) {
  const e = t && t.message;
  return e ? e.error && typeof e.error.message == "string" ? e.error.message : e : "No error message";
}
class L {
  constructor(e) {
    u(this, "_endpoint");
    u(this, "_extra", []);
    u(this, "_tags", {});
    u(this, "_release");
    u(this, "_environment");
    u(this, "_include", []);
    u(this, "_exclude", []);
    u(this, "checkAccessToSendError", (e) => {
      try {
        if (!this._include.length && !this._exclude.length)
          return !0;
        const { message: r } = e;
        let o = !this._include.length;
        return this._include.forEach((s) => {
          r.startsWith(s) && (o = !0);
        }), this._exclude.forEach((s) => {
          r.startsWith(s) && (o = !1);
        }), o;
      } catch {
        return !this._include.length;
      }
    });
    const {
      captureUnhandledErrors: r = !0,
      useProxy: o = !1,
      dsn: s,
      include: n = [],
      exclude: i = [],
      extra: c = [],
      tags: a = {},
      release: h,
      environment: l
    } = e;
    if (this._endpoint = new v(s, o).storeEndpoint, this._extra = c, this._tags = a, this._release = h, this._environment = l, this._include = n, this._exclude = i, r) {
      const f = (p) => {
        this.checkAccessToSendError(p) && this.capture({
          entity: p
        });
      };
      typeof window < "u" && window.addEventListener("error", (p) => f(new Error(p.message))), typeof process < "u" && typeof process.on == "function" && process.on("unhandledRejection", (p) => {
        f(p);
      }).on("uncaughtException", (p) => {
        f(p);
      });
    }
  }
  capture(e) {
    const { entity: r, extra: o = [], tags: s } = e;
    if (d(this._endpoint) && I(this._endpoint)) {
      fetch(this._endpoint, {
        method: "POST",
        body: JSON.stringify(this._createPayload({ entity: r, extra: o, tags: s })),
        referrer: "origin"
      }).catch(() => console.error("Unable to report the error"));
      return;
    }
    throw new Error("Cannot capture, initialize client first");
  }
  _createPayload(e) {
    const { entity: r, extra: o = [], tags: s } = e;
    return {
      timestamp: new Date().toISOString(),
      platform: "javascript",
      message: r.message,
      release: d(this._release) ? this._release : "",
      environment: d(this._environment) ? this._environment : "",
      tags: { ...this._tags, ...s },
      extra: {
        captured: D(r),
        ...[...this._extra, ...o].reduce((n, i) => {
          const c = r;
          return typeof c[i] < "u" && (n[i] = c[i]), n;
        }, {})
      },
      request: this._getRequestInfo()
    };
  }
  _getRequestInfo() {
    if (typeof window < "u") {
      const { location: e, document: r, navigator: o } = window, s = d(e) ? e.href : void 0, n = d(r) ? r.referrer : "", i = d(o) ? o.userAgent : "", c = d(r) ? r.cookie : "";
      return {
        url: s,
        headers: {
          referer: n,
          ["user-agent"]: i
        },
        cookies: c
      };
    }
  }
}
const z = /(?:^|[-_])(\w)/g, F = (t) => t.replace(z, (e) => e.toUpperCase()).replace(/[-_]/g, ""), G = "<Root>", w = "<Anonymous>", V = (t, e) => t.repeat ? t.repeat(e) : t, $ = (t, e) => {
  if (!t)
    return w;
  if (t.$root === t)
    return G;
  if (!t.$options)
    return w;
  const r = t.$options;
  let o = r.name || r._componentTag;
  const s = r.__file;
  if (!o && s) {
    const n = s.match(/([^/\\]+)\.vue$/);
    n && ([, o] = n);
  }
  return (o ? `<${F(o)}>` : w) + (s && e !== !1 ? ` at ${s}` : "");
}, X = (t) => {
  if (t && (t._isVue || t.__isVue) && t.$parent) {
    const e = [];
    let r = 0;
    for (; t; ) {
      if (e.length > 0) {
        const s = e[e.length - 1];
        if (s.constructor === t.constructor) {
          r++, t = t.$parent;
          continue;
        } else
          r > 0 && (e[e.length - 1] = [s, r], r = 0);
      }
      e.push(t), t = t.$parent;
    }
    return `

found in

${e.map(
      (s, n) => `${(n === 0 ? "---> " : V(" ", 5 + n * 2)) + (Array.isArray(s) ? `${$(s[0])}... (${s[1]} recursive calls)` : $(s))}`
    ).join(`
`)}`;
  }
  return `

(found in ${$(t)})`;
}, Q = (t) => {
  const e = $(t, !1), r = X(t);
  return {
    componentName: e,
    trace: r
  };
};
export {
  L as SentryClient,
  $ as formatComponentName,
  X as generateComponentTrace,
  Q as getComponentMetadata
};
